import React from "react";
import clsx from 'clsx';
import { ServiceDialog, ConfirmButton, CancelButton } from "../../../styling/Styles";

const LogoutPopUp = (props) => {

    const{
        openAlert,
        setOpenAlert,
        handleLogout
    }=props;

    const closePopUp = () => {
        setOpenAlert(false);
    }

    return (
            <ServiceDialog
                open={openAlert}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            > 
                 <div className={clsx('titlePopUp','paddingTitle')}> 
                    <span>Logging out</span>
                    <div onClick={closePopUp} aria-hidden="true" className={clsx('pop-up-close-btn')}>x</div>
                </div>
                 <div className ='paddingTitle'>
                    
                    
                        <div className={clsx('spacingTopDiv')} style={{display: 'flex', justifyContent: 'center'}}>
                            Are you sure you want to log out
                        </div>
                    
                    <div  
                        style={{
                            justifyContent:'space-between',
                            display: 'flex',
                            flexDirection: 'row', 
                            marginTop: '2vw',
                        }}

                    >
                        <div >   
                            <CancelButton onClick={closePopUp}>
                                Cancel
                            </CancelButton>
                        </div>
                        <div className={clsx('flexRowDirection')}>
                            <ConfirmButton onClick={handleLogout}>
                                Log out
                            </ConfirmButton>
                        </div>
                    </div>
                </div>

            </ServiceDialog>
		)
}

export default LogoutPopUp;